import { Button } from "@/components/ui/button";
import { ArrowRight, Share2, Gift, Wallet } from "lucide-react";
import { Link } from "react-router-dom";

const steps = [
  {
    icon: Share2,
    step: "1",
    title: "Share Your Link",
    description: "Get your unique referral link and share it with friends or on social media.",
  },
  {
    icon: Gift,
    step: "2",
    title: "Friends Sign Up",
    description: "When someone uses your link to join and pay, you earn a commission.",
  },
  {
    icon: Wallet,
    step: "3",
    title: "Get Paid",
    description: "Withdraw your earnings on weekdays to your bank account.",
  },
];

const Affiliate = () => {
  return (
    <section className="py-32 bg-muted/30">
      <div className="container">
        <div className="max-w-4xl mx-auto">
          {/* Header */}
          <div className="text-center mb-16">
            <h2 className="font-display text-3xl md:text-4xl font-bold text-foreground mb-5">
              Bring a Friend, Grow Together.
            </h2>
            <p className="text-muted-foreground text-lg max-w-lg mx-auto">
              Share TERALEARN with someone you care about — and earn <span className="font-semibold text-accent">₦4,000</span> when they join.
            </p>
          </div>

          {/* Steps */}
          <div className="grid md:grid-cols-3 gap-10 mb-16">
            {steps.map((item, index) => (
              <div
                key={item.title}
                className="text-center animate-fade-up"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="w-14 h-14 rounded-2xl bg-primary/8 flex items-center justify-center mx-auto mb-5 relative icon-pop">
                  <item.icon className="w-6 h-6 text-primary" />
                  <span className="absolute -top-2 -right-2 w-6 h-6 rounded-full bg-accent text-accent-foreground text-xs font-bold flex items-center justify-center">
                    {item.step}
                  </span>
                </div>
                <h3 className="font-display text-lg font-semibold text-foreground mb-2">
                  {item.title}
                </h3>
                <p className="text-muted-foreground text-sm leading-relaxed">
                  {item.description}
                </p>
              </div>
            ))}
          </div>

          {/* CTA */}
          <div className="text-center">
            <Link to="/signup">
              <Button variant="default" size="lg">
                Join Referral Program
                <ArrowRight className="w-4 h-4" />
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Affiliate;
